module.exports = __webpack_public_path__ + "static/media/wolf.6c4cd722.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animalImage/img/wolf.svg
// module id = 168
// module chunks = 0